import { render, staticRenderFns } from "./IdentificationChecksFraud.vue?vue&type=template&id=b9ccc01a&scoped=true"
import script from "./IdentificationChecksFraud.vue?vue&type=script&lang=js"
export * from "./IdentificationChecksFraud.vue?vue&type=script&lang=js"
import style0 from "./IdentificationChecksFraud.vue?vue&type=style&index=0&id=b9ccc01a&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b9ccc01a",
  null
  
)

export default component.exports